import { ComposicaoRda } from './composicao-rda.model';

export class ObrigacaoRepassada {

  id: number;
  composicaoIncentivada: ComposicaoRda;
  composicaoContratante: ComposicaoRda;
  instituicaoPublica: number;
  instituicaoPrivada: number;
  instituicaoOutraRegiao: number;
  remanescentePdi: number;
  fndctDeposito: number;
  trocaPpbPdi: number;

  constructor(init?: Partial<ObrigacaoRepassada>) {
    Object.assign(this, init);
  }

}
